import { createTheme } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: '#5E6578',
    }
  },
  typography: {
    fontFamily: [
      'Poppins',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Poppins',
      fontWeight: '700',
      fontSize: '3.3rem',
      '@media (min-width:600px)': {
        fontSize: '5rem',
      },
      // lineHeight: '52px',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: '600',
    },
    h3: {
      fontSize: '20px',
      fontWeight: '800',
      textAlign: 'center',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      paddingBottom: '1rem',
      color: '#5E6578',
    },
    h4: {
      fontWeight: '800',
      fontSize: '20px',
      color: '#606060',
    },
    body1: {
      fontWeight: '300',
      fontSize: '16px',
      lineHeight: '22px',
    },
    body2: {
      fontWeight: '400',
      fontSize: '21px',
      lineHeight: '40px',
      letterSpacing: '0.05em',
    },
    subtitle1: {
      fontWeight: '800',
      fontColor: '#606060',
      letterSpacing: '-0.015em',
      lineHeight: '48px',
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          // background: 'none',
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%)',
          boxShadow: 'none',
          fontFamily: [
            'Poppins',
            '"Helvetica Neue"',
            'sans-serif',
          ].join(','),
          textTransform: 'uppercase',
          position: 'absolute',
          zIndex: 1,
          paddingTop: '1rem',
          paddingBottom: '1rem'
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          textTransform: 'uppercase',
          '&:hover': {
            background: 'none',
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: [
            'Poppins',
            '"Helvetica Neue"',
            'sans-serif',
          ].join(','),
        }
      }
    },
  }
  // components: {
  //   // Name of the component
  //   MuiButton: {
  //     styleOverrides: {
  //       // Name of the slot
  //       root: {
  //         // Some CSS
  //         fontSize: '1rem',
  //       },
  //     },
  //   },
  // },
});

// theme = responsiveFontSizes(theme);

export default theme;